import { fadeInScaleUpTransition as t } from "./highrise1455.mjs";
import { fadeInTransition as i } from "./highrise1492.mjs";
import { c as e, cB as o } from "./highrise314.mjs";
import { DRAGGABLE_CLASS as r } from "./highrise177.mjs";
const d = e([o("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), o("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [i({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), o("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [o("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), o("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [t({
  duration: ".25s",
  enterScale: ".5"
}), e(`.${r}`, `
 cursor: move;
 user-select: none;
 `)])]);
export {
  d as default
};
